// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_vTf","cls2":"FilterPanel-cls2_VjU FilterPanel-cls1_vTf"};